function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M12.5 12H14m-1.5 0h2"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M16.25 10.25c.967 0 1.75.783 1.75 1.75v0a1.75 1.75 0 01-1.75 1.75v0A1.75 1.75 0 0114.5 12v0c0-.967.783-1.75 1.75-1.75v0zM9.3 13.5c.966 0 1.75.783 1.75 1.75v0A1.75 1.75 0 019.3 17v0a1.75 1.75 0 01-1.75-1.75v0c0-.967.783-1.75 1.75-1.75v0zm0-6.5c.966 0 1.75.784 1.75 1.75v0A1.75 1.75 0 019.3 10.5v0a1.75 1.75 0 01-1.75-1.75v0C7.55 7.783 8.333 7 9.3 7v0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M9.3 13.5v-3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
}));